import ApiRoutes from "../../../constants/api-routes";
import querystring from "querystring";
import ntbInstance from "../../../config/axios/axios-instance";
import loginReducer from "../redux/loginReducer";
import store from "../../../store/store";
import { getDsoDataByCif } from "../../console/services/console.service";
import { getErrorMessage, showNotification } from "../../../helpers/notification-helper";
import Types from "../../../constants/types";

export const getToken = async () =>
  await ntbInstance.post(
    `${ApiRoutes.TOKEN}`,
    querystring.stringify({
      grant_type: "client_credentials",
    }),
  );

export const aoNewRequest = async (body) => {
  try {
    const response = await ntbInstance.post(`${ApiRoutes.AO_NEW_REQUEST}`, body);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      store.dispatch(loginReducer.actions.setRequestId(response.data.data.RequestId));
      store.dispatch(loginReducer.actions.setCustomerId(response.data.data.Customer.CustomerId));
      store.dispatch(loginReducer.actions.setAoNewRequestData(response.data.data));
      await getDsoDataByCif(store.getState().loginReducer.requestId, store.getState().loginReducer.cifNo);
      return true;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
      return false;
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error("API Error");
  }
};

export const dsoLogin = async (body) => {
  try {
    return await ntbInstance.post(`${ApiRoutes.DSO_LOGIN}`, body);
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error("API Error");
  }
};

export const getNicRelatedInfo = async (nic) => {
  try {
    const response = await ntbInstance.get(`${ApiRoutes.GET_NIC_RELATED_INFO}?nicNo=${nic}`);
    if (response.data.ResponseCode === Types.API_SUCCESS_CODE) {
      return response.data;
    } else if (response.data.ResponseCode === Types.API_FAILED_CODE) {
      showNotification("ERROR", response.data.ResponseFrendlyMessage);
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error("API Error");
  }
};

export const otpVerification = async (body) => {
  try {
    const response = await ntbInstance.post(`${ApiRoutes.OTP_VERIFICATION}`, body);
    if (response.data.ResponseCode === "000") {
      return response.data;
    } else {
      showNotification("ERROR", "Invalid OTP. Please try again");
    }
  } catch (e) {
    showNotification("ERROR", getErrorMessage(e));
    throw new Error("API Error");
  }
};
